import { z } from 'zod';

export const roleFormSchema = z
  .object({
    name: z.string().trim().min(1, 'Role name is required'),
    display_name: z.string().optional(),
    description: z.string().optional(),
    organization: z.string().optional(),
    // organization_id can be a number (API response per RoleRow) or string (form
    // input per RoleFormValues), and can be null when the role is global.
    organization_id: z.union([z.string(), z.number(), z.null()]).optional(),
    organization_name: z.string().nullable().optional(),
    permissions: z
      .array(z.number())
      .min(1, 'Select at least one permission'),
    permission_codenames: z.array(z.string()).optional(),
    user_count: z.number().optional(),
    members_count: z.number().optional(),
    permissions_count: z.number().optional(),
    is_system_role: z.boolean().optional(),
    status: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.is_system_role) return;
    const id = data.organization_id;
    const empty =
      id === null ||
      id === undefined ||
      (typeof id === 'string' && id.trim() === '') ||
      (typeof id === 'number' && id <= 0);
    if (empty) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['organization_id'],
        message: 'Select an organization',
      });
    }
  });
